module.exports = __webpack_public_path__ + "static/scen-7-16a860d94982b67f264a3bd6a6d7fb76.svg";